// import { Client } from "twitter-api-sdk";
import { Typography } from '@mui/material';
import { Box } from '@mui/system';
import ScrollingBlogBanner from './ScrollingBlogBanner';

const BEARER_TOKEN = 'AAAAAAAAAAAAAAAAAAAAAFipmQEAAAAAKJ8CE7yA783f5zdyCE3lQwW6QPI%3D9K0kVBVMtucMzoF6Da2eZIQo8f3cw8kbMqWJR2LUKH1hbP3mZB';
const ACCESS_TOKEN = '842853695855493120-pdGiMmLwGJnjxm2nOpjKWVxujbp4GGD';
const ACCESS_TOKEN_SECRET = 'rWAuJSkojknNQRYYWjsspTBnM83qdVh6kNbve9hYzxod2';

export const main = async () => {
  // const client = new Client("MY-BEARER-TOKEN");
  // const tweet = await client.tweets.findTweetById("20");
  // console.log(tweet.data.text);
};

const RecentBlogs = ({ blogDetails }) => {
  return (
    <div id='blogs' className='w-full'>

      <Box className='flex justify-center text-start mt-8 w-full' id='recent-tweets'>
        <Typography variant='h4' className='w-full max-w-7xl px-5 md:px-8' sx={{ color: 'primary.yorisWhite' }}>Blogs</Typography>
      </Box>

      {/*Scrolling Banner */}
      <Box className='w-full flex flex-col pt-8 pb-16 gap-1'>
        {
          blogDetails.map(item => (
            <ScrollingBlogBanner images={item.images} speed={item.speed} direction={item.direction} />
          ))
        }
      </Box>
    </div>
  )
}

export default RecentBlogs;